import {Component, Inject, OnInit} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {SuiviReleveServiceHttp} from "@services/admin/ca/suivi-releve-service-http.service";
import {OpeCarteDetail} from "@domain/admin/ca/ope-carte-detail";
import {EtatCarte} from "@domain/admin/ca/ope-log-error";
import {TranslateService} from "@ngx-translate/core";
import {finalize} from "rxjs/operators";
import {Alerte, NiveauAlerte} from "@domain/common/alerte/alerte";

/**
 * Composant de détail d'une opération en erreur
 *
 * @author Guillaume TRAVOT
 * @date 31/03/2026
 */
@Component({
    host: {'data-test-id': 'suivi-releve-error-detail'},
    selector: 'suivi-releve-error-detail',
    templateUrl: './suivi-releve-error-detail.component.html',
    styles: ['.alert-banner { background-color: #f8d7da; border: 1px solid #f5c6cb; border-radius: 4px; padding: 12px 16px; margin-bottom: 16px; } .alert-banner .alert-icon { color: #721c24; margin-right: 8px; } .alert-banner .alert-content { color: #721c24; }']
})
export class SuiviReleveErrorDetailComponent implements OnInit {
    /** Indique si le composant est en cours de chargement  */
    isLoading: boolean = true;

    /** Objet contenant le détail de l'opération  */
    detailOpeCarte: OpeCarteDetail;

    /** Alerte */
    alerte: Alerte;

    /**
     * Constructeur
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            idOpeCarte: string,
            typesErreur: Array<{code: EtatCarte, libelle: string, solution: string}>
        },
        private suiviReleveServiceHttp: SuiviReleveServiceHttp,
        private translateService: TranslateService,
        private matDialogRef: MatDialogRef<SuiviReleveErrorDetailComponent, boolean>
    ) {}

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        this.loadDetail();
    }

    /**
     * Charge le détail de l'opération
     */
    private loadDetail(): void {
        this.isLoading = true;
        this.suiviReleveServiceHttp.getDetailOpeCarte(this.data.idOpeCarte)
            .pipe(finalize(() => this.isLoading = false))
            .subscribe(result => {
                if (result?.data?.detailOpeCarte) {
                    this.detailOpeCarte = new OpeCarteDetail(result.data.detailOpeCarte);
                    this.setLibellesErreur();
                }
            });
    }

    /**
     * Définit les libellés des erreurs
     */
    private setLibellesErreur(): void {
        const typeErreur = this.data.typesErreur.find(t => t.code === this.detailOpeCarte.erreur);
        if (typeErreur) {
            this.alerte = new Alerte({
                niveau: NiveauAlerte.ERROR,
                titre: this.translateService.instant(typeErreur.libelle),
                message: typeErreur.solution ? this.translateService.instant(typeErreur.solution) : null
            });
        } else {
            this.alerte = new Alerte({
                niveau: NiveauAlerte.ERROR,
                titre: this.translateService.instant('admin.frais.cartes.suivi.erreur.NON_REFERENCE'),
                message: this.translateService.instant('admin.frais.cartes.suivi.solution.NON_REFERENCE')
            });
        }
    }

    /**
     * Ferme la fenêtre
     */
    close(): void {
        this.matDialogRef.close(false);
    }
}